import { useMemo } from 'react';

export default function CardsSection() {
  const cards = useMemo(() => [
    {
      id: 1,
      image: 'https://readdy.ai/api/search-image?query=Digital%20abstract%20composition%20with%20flowing%20data%20visuals%2C%20warm%20red%20and%20amber%20tones%2C%20mysterious%20dark%20background%2C%20representing%20information%20leak%20and%20breaking%20news%2C%20minimalist%20geometric%20style%2C%20no%20text%20no%20faces&width=600&height=400&seq=card-guagua-01&orientation=landscape',
      tag: '娱乐圈',
      title: '明星大瓜年度盘点：那些轰动全网的名场面',
      time: '3小时前',
      views: '128.6k',
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Abstract%20network%20visualization%20with%20interconnected%20nodes%20glowing%20in%20crimson%20and%20gold%2C%20dark%20atmosphere%2C%20representing%20social%20media%20trends%20and%20viral%20topics%2C%20futuristic%20style%2C%20no%20text%20no%20faces&width=600&height=400&seq=card-guagua-02&orientation=landscape',
      tag: '社会热点',
      title: '全网热议！最新社会事件完整追踪与分析',
      time: '5小时前',
      views: '95.2k',
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Digital%20eye%20symbol%20surrounded%20by%20encrypted%20data%20cascades%2C%20warm%20amber%20and%20deep%20red%20gradients%2C%20mysterious%20surveillance%20theme%2C%20dark%20background%2C%20no%20text%20no%20faces&width=600&height=400&seq=card-guagua-03&orientation=landscape',
      tag: '网络热议',
      title: '吃瓜第一线：本周最劲爆的网络话题速览',
      time: '8小时前',
      views: '76.8k',
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=Laptop%20screen%20with%20glowing%20red%20code%20and%20data%20patterns%2C%20dark%20room%20atmosphere%2C%20representing%20hidden%20internet%20secrets%2C%20cyber%20noir%20style%2C%20cinematic%20lighting%2C%20no%20text%20no%20faces&width=600&height=400&seq=card-guagua-04&orientation=landscape',
      tag: '独家爆料',
      title: '暗网独家：那些不为人知的幕后故事合集',
      time: '12小时前',
      views: '63.4k',
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=Abstract%20soundwave%20and%20data%20ripple%20pattern%20in%20warm%20red%20and%20gold%20colors%2C%20dark%20digital%20background%2C%20representing%20live%20streaming%20and%20real%20time%20updates%2C%20minimalist%20style%2C%20no%20text%20no%20faces&width=600&height=400&seq=card-guagua-05&orientation=landscape',
      tag: '直播回顾',
      title: '昨夜直播精彩回顾：暗网吃瓜直播高光时刻',
      time: '1天前',
      views: '52.1k',
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=Multiple%20screens%20displaying%20abstract%20data%20visualizations%20in%20warm%20tones%2C%20monitoring%20room%20atmosphere%2C%20representing%20information%20tracking%20and%20analysis%2C%20cyber%20style%2C%20no%20text%20no%20faces&width=600&height=400&seq=card-guagua-06&orientation=landscape',
      tag: '深度追踪',
      title: '完整时间线：某顶流事件从发酵到终结全记录',
      time: '2天前',
      views: '48.9k',
    },
    {
      id: 7,
      image: 'https://readdy.ai/api/search-image?query=Glowing%20envelope%20icon%20floating%20in%20digital%20space%20with%20data%20particles%2C%20warm%20amber%20and%20red%20highlights%2C%20dark%20background%2C%20representing%20leaked%20information%20and%20secret%20documents%2C%20minimalist%2C%20no%20text%20no%20faces&width=600&height=400&seq=card-guagua-07&orientation=landscape',
      tag: '热门合集',
      title: '本月必看：51吃瓜在线精选视频TOP20',
      time: '3天前',
      views: '41.3k',
    },
  ], []);

  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            热门吃瓜速递
          </h2>
          <p className="text-sm text-foreground-500 mt-3">精选最新最热的吃瓜内容，不错过每一个瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
          {cards.slice(0, 7).map((card) => (
            <article
              key={card.id}
              className={`bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-200 group cursor-pointer ${
                card.id === 7 ? 'sm:col-span-2 lg:col-span-3 xl:col-span-4 max-w-md mx-auto' : ''
              }`}
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}